// extracted by mini-css-extract-plugin
export default {"title":"category_title","link":"category_link"};